var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useState } from "react";
import { getViewportSize } from "@react-md/utils";
import { DEFAULT_TOOLTIP_THRESHOLD } from "./constants";
/** @internal */
var noop = function () {
    // do nothing
};
/**
 * A hook that's used to determine the "best" position to render the tooltip
 * within the viewport.
 *
 * @internal
 * @remarks \@since 2.8.0
 */
export function useTooltipPosition(_a) {
    var determinedPosition = _a.position, _b = _a.defaultPosition, defaultPosition = _b === void 0 ? "below" : _b, _c = _a.threshold, threshold = _c === void 0 ? DEFAULT_TOOLTIP_THRESHOLD : _c;
    var _d = __read(useState(defaultPosition), 2), position = _d[0], setPosition = _d[1];
    var updatePosition = useCallback(function (container) {
        var _a = container.getBoundingClientRect(), top = _a.top, left = _a.left;
        var vh = getViewportSize("height");
        var vw = getViewportSize("width");
        var nextPosition = defaultPosition;
        if (defaultPosition === "above" && top < vh * threshold) {
            nextPosition = "below";
        }
        else if (defaultPosition === "below" && top > vh * threshold) {
            nextPosition = "above";
        }
        else if (defaultPosition === "left" && left < vw * threshold) {
            nextPosition = "right";
        }
        else if (defaultPosition === "right" && left > vw * threshold) {
            nextPosition = "left";
        }
        setPosition(nextPosition);
    }, [defaultPosition, threshold]);
    if (typeof determinedPosition !== "undefined") {
        return [determinedPosition, noop];
    }
    return [position, updatePosition];
}
//# sourceMappingURL=useTooltipPosition.js.map